import React, { PureComponent } from 'react';
import { TouchableOpacity, View } from 'react-native';
import Button from '@dbk/ui-buttons';
import { createContainer } from '@dbk-legacy/muster/react'
import { Transactions, NotificationWarning } from '@dbk/ui-icons'

class PaymentPsdBanner extends PureComponent {

  onViewClick(e) {
    const { i18n: { messages }, ais: { isBannerVisible, isServiceActionAIS, getAISConsent, setErrorMsg } } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      if (isBannerVisible && isServiceActionAIS) {
        getAISConsent();
          this.props.changePage('/psd2/aisflow');

      } else if (isBannerVisible && isServiceActionAIS === false) {
      // setErrorMsg(messages['app.psd2.payment.generic.errorMsg']);
        this.props.changePage('psd2/pisflow');
      }else if(setErrorMsg){
        setErrorMsg(messages['app.psd2.payment.generic.errorMsg']);
      }
      this.props.setIsBannerShow(false);
    }
  }

  render() {
    const { i18n: { messages },ais: { isBannerVisible, isServiceActionAIS, getAISConsent, setErrorMsg } } = this.props;
    return (
      <div accessible={false} className="bannerContainer">
        <div className="bannerIcon">
          <NotificationWarning color={'#FFA500'} width={30} height={30} />
        </div>

        <div className="bannerMsg" tabIndex={0}>
          {isServiceActionAIS ? messages['app.payment.psd2.consent.banner'] : messages['app.payment.psd2.paymentBanner']}
        </div>
        <div className="btnView">
          <Button onKeyDown={() => this.onViewClick()} onClick={() => this.onViewClick()} role="button" tabIndex={0}>
            {messages['app.payments.confirmationBtn']}
          </Button>
        </div>

      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    auth: {
      addBeneficiaryDisabled: true
    },
    changePage: { $call: 'ui.history.push' },
    ais: {
      isBannerVisible: true,
      isServiceActionAIS: true,
      getAISConsent: { $call: 'getAISConsent' },
      setErrorMsg: { $set: 'errorMsg' }
    },
    setIsBannerShow: { $set: 'ais.isBannerVisible' }
  },
})(PaymentPsdBanner)
